import { useTranslation } from 'react-i18next';
import { HiBuildingLibrary } from 'react-icons/hi2';
import {
  Section,
  Container,
  Content,
  Label,
  Title,
  Description,
  Badge,
  Preview,
  PreviewSearch,
  PreviewItem,
  PreviewCourtName,
  PreviewAccount,
} from './CourtAccounts.styled';

const courtExamples = [
  {
    name: 'Sąd Rejonowy dla m.st. Warszawy',
    account: '12 1020 1042 0000 8202 0276 6001',
  },
  {
    name: 'Sąd Okręgowy w Krakowie',
    account: '97 1130 1150 0012 1268 0420 0001',
  },
];

export default function CourtAccounts() {
  const { t } = useTranslation();

  return (
    <Section id="konta-sadow">
      <Container>
        <Content>
          <Label>{t('courtAccountsSection.label')}</Label>
          <Title>{t('courtAccountsSection.title')}</Title>
          <Description>{t('courtAccountsSection.description')}</Description>
          <Badge>
            <HiBuildingLibrary size={16} />
            {t('courtAccountsSection.badge')}
          </Badge>
        </Content>
        <Preview>
          <PreviewSearch>{t('courtAccountsSection.searchPlaceholder')}</PreviewSearch>
          {courtExamples.map((court) => (
            <PreviewItem key={court.name}>
              <PreviewCourtName>{court.name}</PreviewCourtName>
              <PreviewAccount>{court.account}</PreviewAccount>
            </PreviewItem>
          ))}
        </Preview>
      </Container>
    </Section>
  );
}
